import api from '@/http'

export default {
  data () {
    return {
      editorConfig: {
        theme: 'modern',
        plugins: 'autoresize preview fullpage fullscreen image link autolink media directionality codesample table charmap hr anchor toc insertdatetime advlist lists textcolor wordcount imagetools contextmenu colorpicker textpattern help paste',
        toolbar: 'fontselect formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent',
        fontsize_formats: '8pt 9pt 10pt 11pt 12pt 13pt 14pt 16pt 18pt 20pt 24pt 32pt 36pt 48pt',
        branding: false,
        paste_data_images: true,
        automatic_uploads: true,
        images_reuse_filename: true,
        images_upload_handler: async (blobInfo, success, failure) => {
          let data = new FormData()
          const request = async () => {
            return api.post('/image/upload', data)
              .then(response => {
                return {
                  success: true,
                  response
                }
              })
              .catch(error => {
                return {
                  success: false,
                  error
                }
              })
          }
          data.append('image', blobInfo.blob())
          let upload = await request()

          if (upload.success) {
            success(upload.response.data)
          } else {
            if (upload.error.response.status === 409) {
              if (confirm('Replacing this image will update the image everywhere, are you sure you want to continue?')) {
                data.append('force', 1)
                let reTryUpload = await request()
                if (reTryUpload.success) {
                  success(reTryUpload.response.data)
                } else {
                  failure(reTryUpload.error)
                }
              } else {
                failure('User rejected image upload')
              }
            } else {
              failure(upload.error)
            }
          }
        }
      }
    }
  }
}
